import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getListBrand } from "../../server/brand";
import { Skeleton } from "../../components/Skeleton";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, FreeMode } from "swiper/modules";

import { cleanUrl } from "../../contants";
import "swiper/css";
import "swiper/css/navigation";

export default function BrandHome() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [brokenIds, setBrokenIds] = useState<Set<string>>(new Set());

  useEffect(() => {
    async function load() {
      try {
        const res = await getListBrand();
        setData(res ?? []);
      } catch (error) {
        console.error("Error load brand:", error);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  const isSlider = data.length >= 10;

  const handleSelectBrand = (brandId: string) => {
    if (!brandId) return;
    navigate(`/danh-muc-san-pham?brandId=${encodeURIComponent(brandId)}`);
  };

  const renderBrandLogo = (brand: any) => {
    const url = cleanUrl(brand?.attachment?.fileUrl ?? "");
    const isBroken = brokenIds.has(brand.brandId) || !url;
    const initial =
      (brand?.brandName?.trim()?.[0] || "?").toLocaleUpperCase();

    if (isBroken) {
      return (
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-slate-100 text-base font-bold text-slate-700 shadow-inner">
          {initial}
        </div>
      );
    }

    return (
      <div className="flex h-12 w-12 items-center justify-center">
        <img
          src={url}
          alt={brand?.brandName || ""}
          className="h-full w-full rounded-xl object-contain"
          onError={(e) => {
            e.currentTarget.onerror = null;
            setBrokenIds((prev) => {
              const next = new Set(prev);
              next.add(brand.brandId);
              return next;
            });
          }}
        />
      </div>
    );
  };

  return (
    <section className="px-4 py-10">
      <div className="mx-auto max-w-7xl space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="section-eyebrow">Thương hiệu</p>
          </div>
          {/* <span className="chip text-xs">{data.length} thương hiệu</span> */}
        </div>

        <div className="glass-card border border-slate-100 bg-white p-4">
          {loading ? (
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6">
              {Array.from({ length: 12 }).map((_, idx) => (
                <Skeleton key={idx} className="h-12 w-full rounded-xl" />
              ))}
            </div>
          ) : isSlider ? (
            <Swiper
              modules={[Navigation, FreeMode]}
              navigation
              freeMode
              slidesPerView={8}
              spaceBetween={15}
              breakpoints={{
                320: { slidesPerView: 3 },
                640: { slidesPerView: 5 },
                1024: { slidesPerView: 8 },
              }}
            >
              {data?.map((brand) => {
                return (
                  <SwiperSlide key={brand.brandId}>
                    <button
                      type="button"
                      onClick={() => handleSelectBrand(brand.brandId)}
                      className="flex w-full items-center justify-start gap-3 rounded-xl border border-slate-100 bg-slate-50 px-4 py-3 text-left transition hover:-translate-y-1 hover:bg-white"
                    >
                      {renderBrandLogo(brand)}
                      <div className="flex-1 text-sm font-semibold text-slate-800 line-clamp-1">
                        {brand?.brandName || "Thương hiệu"}
                      </div>
                    </button>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          ) : (
            <div
              className={`grid gap-4 ${
                data.length <= 3
                  ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
                  : "grid-cols-2 sm:grid-cols-3 md:grid-cols-4"
              }`}
            >
              {data?.map((brand) => {
                return (
                  <button
                    type="button"
                    key={brand.brandId}
                    onClick={() => handleSelectBrand(brand.brandId)}
                    className="flex items-center justify-start gap-3 rounded-xl border border-slate-100 bg-slate-50 px-4 py-3 text-left transition hover:-translate-y-1 hover:bg-white"
                  >
                    {renderBrandLogo(brand)}
                    <div className="flex-1 text-sm font-semibold text-slate-800 line-clamp-1">
                      {brand?.brandName || "Thương hiệu"}
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
